(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-redit"] && !Shopify.designMode) return;
  try {
    (function () {
    function initReditSliders() {
      var sliders = document.querySelectorAll('[class^="c-redit-"]');

      sliders.forEach(function (container) {
        if (container.dataset.initialized === 'true') return;

        var swiperEl = container.querySelector('.swiper');
        if (!swiperEl) return;

        var scope = container.className.split(' ')[0];
        var prevBtn = container.querySelector('[class*="__arrow--prev"]');
        var nextBtn = container.querySelector('[class*="__arrow--next"]');
        var pagination = container.querySelector('[class*="__pagination"]');

        var autoplay = container.dataset.autoplay === 'true';
        var autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;

        var swiperConfig = {
          slidesPerView: 1,
          loop: true,
          grabCursor: true,
          keyboard: {
            enabled: true,
          },
          a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          },
        };

        if (autoplay) {
          swiperConfig.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        if (prevBtn && nextBtn) {
          swiperConfig.navigation = {
            prevEl: prevBtn,
            nextEl: nextBtn,
          };
        }

        if (pagination) {
          swiperConfig.pagination = {
            el: pagination,
            clickable: true,
          };
        }

        if (typeof Swiper !== 'undefined') {
          new Swiper(swiperEl, swiperConfig);
          container.dataset.initialized = 'true';
        } else {
          // Swiper not loaded yet, try again
          setTimeout(function () {
            if (typeof Swiper !== 'undefined') {
              new Swiper(swiperEl, swiperConfig);
              container.dataset.initialized = 'true';
            }
          }, 500);
        }
      });
    }

    // Run on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReditSliders);
    } else {
      initReditSliders();
    }

    // Also try after a short delay in case Swiper loads async
    setTimeout(initReditSliders, 100);
    setTimeout(initReditSliders, 500);

    // Shopify theme editor support
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initReditSliders);
      document.addEventListener('shopify:block:select', initReditSliders);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
